export const scalingPolicyVpaSettingsList = [
  'optimizedResources',
  'customMetrics',
  'excludedContainers',
  'autoscaler',
  'predictiveScaling',
  'overhead',
  'memoryGrowthDetection',
  'stallDetection',
  'recommendationPercentile',
  'workloadResourceLimits',
  'workloadConstraints',
  'lookbackPeriod',
  'startupMetrics',
  'confidence',
  'hpaConverter',
] as const;

export type ScalingPolicyVpaFormFields =
  (typeof scalingPolicyVpaSettingsList)[number];

export const newVpaSettings: ScalingPolicyVpaFormFields[] = ['hpaConverter'];

export const scalingPolicyHpaSettingsList = [
  'takeOwnership',
  'basicBehavior',
  'metrics',
  'autoscalerBehavior',
] as const;

export type ScalingPolicyHpaFormFields =
  (typeof scalingPolicyHpaSettingsList)[number];
